// Quick add popup trigger (function, it's called further down inside another wrapper
// This is because we need to trigger the cart add functions, but they were all injected into the page inside a wrapper function
// Couldn't get them from here, so migrated the scipts into this page
quickAddPopup();


function quickAddPopup() {
  
  var checkIfCollectionPage = document.querySelectorAll('.collection-page-v2');

  // Make sure we've actually got the correct snippet before looking for contents
  if(checkIfCollectionPage.length) {
    
    console.log("IS COLLECTION TYPE: Running Quick add");
    
    var products = document.querySelectorAll('.product-block');
    //console.log(products);
    
    var afterpayPopup = document.querySelector('#afterpay-popup-wrapper');
    if(afterpayPopup) {
      // Since we can't use the normal widget for the quickadd popup.
      // The afterpay link needs to be able to trigger (further down), but also close when you click the close icon
      // It doesn't have a ID, so we've got to trigger it by the below.
      var afterpayPopupClose = afterpayPopup.querySelector('a[href="#"] svg');
      afterpayPopupClose.addEventListener('click', function(e) {
        e.preventDefault();
        afterpayPopup.classList.add("is-hidden");
      });
    }
    
    products.forEach( function(product) {
      
      // Get the button and the handle
      var quickAddButton = product.querySelector('.btn--bottom');
      console.log(quickAddButton)
      
      quickAddButton.addEventListener('click', function(e) {
        
        e.preventDefault(); // Stop the button from normal functions
        
        // Work out button of click event
        var target = e.target || e.srcElement;
        
        // Get our handle to parse to the JSON
        var productID = target.dataset.productid;
        var productHandle = target.dataset.producthandle;
        
        // Get the popup itself
        var thisPopup = document.querySelector('#collection-popup-'+productID);
        console.log('productID = ', productID);
        thisPopup.classList.add('active'); // Show the modal
        document.body.classList.add('noScroll'); // Stop the body scrolling
        
        // Get the popup's elements to update
        var popBG = thisPopup.querySelector('.bgwrapper')
        var popVariantSelector = thisPopup.querySelector('.select_variant');
        // var popCartButtonOurOwn = thisPopup.querySelector('.btn-addtocart-ourown');
        var popForm = thisPopup.querySelector('form');
        var popClose = thisPopup.querySelector('.popup-close--wrapper');
        var popRadio = thisPopup.querySelector('input[name="popup_payment_type-'+productID+'"]:checked');
        
        var popAfterpay = thisPopup.querySelector('.afterpay-info');
        
        var popCartButtons = thisPopup.querySelectorAll('.btn-addtocart');
        var btnAddToCart_OneTime = thisPopup.querySelector('.btn-onetime');
        var btnAddToCart_Subs = thisPopup.querySelector('.btn-subs');
        
        // Get the purchase type
        // Get the selected purchase type
        var popPurchaseTypeSelectors = thisPopup.querySelectorAll('.radio');
        
        // Close using X
        popClose.addEventListener('click', function(e) {
          closePopup(thisPopup);
        });
        
        popBG.addEventListener('click', function(e) {
          closePopup(thisPopup);
        });
        
        // Once user has clicked an add to cart button, close the quick popup also
        // popCartButtons.forEach( function(btn){
        // 	btn.addEventListener('click', function(e) {
        //       setTimeout(function(){ 
        //          closePopup(thisPopup);
        //       }, 700);
        //   });
        // });
        
        function closePopup(e) {
          e.classList.remove('active');
          document.body.classList.remove('noScroll');
        }
        
        // Trigger afterpay info
        if(popAfterpay) {
          popAfterpay.addEventListener('click', function(e) {
            afterpayPopup.classList.remove("is-hidden");
          });
        }
        
        
        // We had a normal add to cart button initially. I'll keep this code for now.
        if(popForm && !popForm.classList.contains('withEvent')) { 
          popForm.classList.add('withEvent');
          
          popForm.addEventListener('submit', function(e) {
            e.preventDefault();
            e.stopPropagation();

            let formData = new FormData(e.target);

            formData.append('quantity', 1);

            fetch('/cart/add.js', {
              method: 'POST',
              body: formData
            })
            .then((response) => {
              closePopup(thisPopup);

              fetch('/cart.js')
              .then((response) => response.json())
              .then((cart) => {
                updateCartDrawerUI(cart);
                jQuery(document).trigger('cart.requestComplete',cart);
              })

              toggleCartDrawer(e);
            })
          });
        } // End if popCartButton

      }); // End for each QuickAdd button \ Popup

        
      }); // End Foreach Product

      
    } // End if collection\Single collection page
    
  
  
}







// Function to run the micro accordion on products
productAccordionsNew();

function productAccordionsNew() {
  var accordions = document.querySelectorAll('.product-accordion li');
  if(accordions) {
    accordions.forEach( function(accordion) {
      var title = accordion.querySelector('.product-accordion-title');
      var content = accordion.querySelector('.product-accordion-content');
      if(title && content) {
        title.addEventListener('click', function(e) {
          console.log("clicked");
          title.classList.toggle("active");
          content.classList.toggle("open");
        });
      }
    });
  }
}


// Function to run popups on the new product pages
productPagePopups();

function productPagePopups() {
  
  //Find the custom percentage entry if exists, and put into the popup
  var hiddenPercentEle = document.querySelector('[skio-discount]');
  if(hiddenPercentEle) {
    var hiddenPercent = hiddenPercentEle.textContent;
//     console.log("Grab the hidden discount so we can pass it to JS");
//     console.log(hiddenPercentEle);
//     console.log(hiddenPercent);
    var popupPercentSpan = document.querySelector('.subs_percent');
//     console.log("Find the place where it sill go");
//     console.log(hiddenPercentEle);
    if(popupPercentSpan) {
      var hiddenPercentString = hiddenPercent.trim();
      popupPercentSpan.textContent = hiddenPercentString;
    }
  }
  
  // Scroll down to sections of the page without accordion content (I.E. reviews)
  var smoothLinks = document.querySelectorAll('.smoothLink');
  if(smoothLinks.length) {
    smoothLinks.forEach( function(link) {
      link.addEventListener('click', function(e) {
        let targetID = e.target.dataset.scrolltarget;
        let mytarget = document.querySelector('#'+targetID);
        if(mytarget) {
        	mytarget.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }
      });
    });
  }
  
  
  var popupLinks = document.querySelectorAll('.product-popup-link');
  if(popupLinks.length) {
    
    // Trigger the related popup
    popupLinks.forEach( function(link) {
      
      var relatedPopup = '';
      
      // Open related popup on click
      link.addEventListener('click', function(e) {
        let targetID = e.target.dataset.popupid;
        if(targetID) {
          let target = document.querySelector('#'+targetID);
          console.log(target)
          if(target) {
            target.classList.add("show");
            document.body.classList.add('noScroll');
          }
        }
      });
                             
    });
    
    
    // Individual popup controls
    var productpagePopups = document.querySelectorAll('.productpage_popup');
    if (productpagePopups.length) {
      productpagePopups.forEach( function(popup) {

        // Close on cross click
        var close = popup.querySelector('.popup-close');
        if(close) {
          	console.log(popup);
          	close.addEventListener('click', function(e) {
        		popup.classList.remove("show");
          		document.body.classList.remove('noScroll');
        	});
        }
        
        // Close on background click
        var background = popup.querySelector('.popup-background');
        if(background) {
          	console.log(background);
          	background.addEventListener('click', function(e) {
        		popup.classList.remove("show");
              	document.body.classList.remove('noScroll');
        	});
        }
        

      });
	}
    
    // Unique listeners for the promo popup that's coded into the subscription selector
    var customPromoTriggers = document.querySelectorAll('.customPromoTrigger');
    if(customPromoTriggers.length) {
      customPromoTriggers.forEach( function(trigger) {
        trigger.addEventListener('click', function(e) {
          let subsPopup = document.querySelector('.c-subscription-popup');
          subsPopup.classList.remove('is-hidden');
          document.body.classList.add('scroll-lock');
        });
      });
    }
    
    
  }
}


// Collections filter for mobile
collectionsFilterMobile();

function collectionsFilterMobile() {
  var menu = document.querySelector('.collection_menu');
  if(menu) {
     var filter = menu.querySelector('.collections-filter-withDropdown');
  	var filterBGwrapper = document.querySelector('.collection_background_overlay');
    var title = filter.querySelector('.collections-filter-title');
    var dropdown = filter.querySelector('.collections-filter-dropdown');
    var filterOpen = false;
    
    title.addEventListener('click', function(e) {
      if(filterOpen == false) {
      	dropdown.classList.add('open');
      	filterBGwrapper.classList.add('show');
      	filterOpen = true;
      } else {
        dropdown.classList.remove('open');
      	filterBGwrapper.classList.remove('show');
        filterOpen = false;
      }
    });
    
    filterBGwrapper.addEventListener('click', (event) => {
      dropdown.classList.remove('open');
      filterBGwrapper.classList.remove('show');
      filterOpen = false;
    });
    
    filter.addEventListener('mouseleave', (event) => {
      dropdown.classList.remove('open');
      filterBGwrapper.classList.remove('show');
      filterOpen = false;
    });
    
  }
}



// ====== FUNCTIONS PULLED FROM THE PAGE INJECTION TO RUN THE CART =====

function updateCartDrawerUI(cart) {
  $('body').addClass('cart-loading');

  if ( window.location.pathname === '/cart' ) {
    window.location.reload();
    return;
  }

  fetch("/cart?view=drawer")
  .then(function(data){ return data.text() })
  .then(function(data){
    var newCartEl = $(data);

    $('body').removeClass('cart-loading');
    $('body').addClass('cart-drawer-open');
    $('#shopify-section-cart-drawer').replaceWith(newCartEl);
    $('.cart-drawer').addClass('cart-drawer--visible');
    $('.cart-drawer-bg').addClass('cart-drawer-bg--visible');
    $('#add-to-cart').removeClass('disabled');
    $('.upsells-action .btn').removeClass('disabled');
    updateCheckoutBtn(cart);
    showHideDetails(cart);
    updateUpsellItems(cart);
  })
  .catch(function(e){console.warn(e);});
}



function showHideDetails (cart) {
  var detailsEl = $('.cart-drawer__details');

  if (cartHasSubscription(cart)) {
    detailsEl.show();
  } else {
    detailsEl.hide();
  }
}


function updateCartCount(cart) {
  $('.cartCount').text(cart.item_count ? cart.item_count : '');
}

function handleClickUpdateQty(e) {
  var data = $(this).data(), newQty, qtyEl = $(this).parent().find('.cart-drawer__item-qty-label');
  e.preventDefault();

  newQty = parseInt(qtyEl.text());

  if ( data.action == 'increment' ) {
    newQty = newQty + 1;
  } else if ( data.action == 'decrement' ) {
    newQty = newQty - 1;
    if ( newQty < 0 ) { // never go below zero
      newQty = 0
    }
  }

  qtyEl.text(newQty)

  debouncedCartJsUpdate(data.index, newQty);
}

function updateUpsellItems(cart) {
  var container = $('.cart-drawer__recommendations-items [data-cart-submit="true"]');
  if ( container.length ) {
    inputs = container.find('input[name="id"]');
    inputs.each(function(index, input) {
      var $el = $(input);
      var variantId = $el.data('variant_id')
      $el.attr('value', variantId)
    });
  }
}


function toggleCartDrawer(e) {
  e.preventDefault();
  $('body').toggleClass('cart-drawer-open');
  $('.cart-drawer').toggleClass('cart-drawer--visible');
  $('.cart-drawer-bg').toggleClass('cart-drawer-bg--visible');
}

function setRequestStarted() {
  $('body').addClass('cart-loading');
  $('#add-to-cart').addClass('disabled');
  $('.upsells-action .btn').addClass('disabled');
}

function handleRequestStarted(event, cart) {
  setRequestStarted();
}

function handleRequestComplete(event, cart) {
  updateCartDrawerUI(cart);
  updateCartCount(cart);
}

async function addProductMetafields(product) {
  var url = `/products/${product.handle}?view=metafields`;
  var prod_resp = await fetch(url);

  prod_resp = await prod_resp.json();
  return {...product, metafields: prod_resp}
}

function addAvailableVariant(prod) {
  let available_var;
  let available = prod.variants.filter((variant) => variant.available);

  if ( available.length > 0 ) {
    available_var = available[0] || {};
  }

  prod.first_available_variant = available_var;
  return prod;
}

function cartHasSubscription(cart) {
  return cart.items.filter((item) => item.properties.shipping_interval_frequency ).length > 0
}

async function insertRecommendations(products, cart) {
  if ( !products ) { return; }
  let template = _.template($('#cart_drawer_recommendations_template').html());

  products = products.filter((prod) => {
    var keep = true;
    cart.items.forEach((item) => {
      if ( item.product_id === prod.id || item.title === prod.title ) {
        keep = false;
      }
    });
    return keep;
  });

  products = await Promise.all(products.map(async(prod) => {
                                            prod = addAvailableVariant(prod);
                               prod = await addProductMetafields(prod);
  prod = addSubscriptionVariant(prod);
  return prod;
}));


if ( products.length > 0 ) {
  $('.cart-drawer .cart-drawer__recommendations').html(
    template({
      products: products,
      cart_has_subscription: cartHasSubscription(cart)
    })
  );
  $('.cart-drawer__recommendations').show();
}
}

    

function between(x, min, max) {
  return x >= min && x <= max;
}

function updateCheckoutBtn(cart) {
  var cart_total_without_promo_or_gift_cards = 0,
      settings = {
        has_subscription_in_cart: false,
        gwp_variant_id: 34716071854248 || null
      };
  var tiers = [

  ];

  for ( const [index, item] of cart.items.entries() ) {
    if ( item.properties.shipping_interval_unit_type ) {
      settings.has_subscription_in_cart = true;
    }

    if ( item.id !== settings.gwp_variant_id || !item.properties._free_gift ) {
      if ( item.product_type !== 'Gift Card' ) {
        cart_total_without_promo_or_gift_cards += item.final_line_price;
      }
    }
  }

  if ( settings.has_subscription_in_cart === true ) {
    var checkoutButton = $('.cart-drawer__actions a');
    var tier = tiers.find(el => between(cart_total_without_promo_or_gift_cards, el.min, el.max));
    if ( tier ) {
      checkoutButton.attr('href', 'https://checkout.misterjoneshealth.com/r/checkout?myshopify_domain=mister-jones.myshopify.com&cart_token='.concat(cart.token, '&discount=', tier.code));
    } else {
      checkoutButton.attr('href', 'https://checkout.misterjoneshealth.com/r/checkout?myshopify_domain=mister-jones.myshopify.com&cart_token='.concat(cart.token));
    }
    console.log('updated checkout button');
  }
}

function togglePromoDetailsContent() {
  $('.promos-unlocked__details').toggle();
  $('.cart-drawer__details .cart-drawer__item-link img').toggleClass('rotate');
}
